import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/overtime-calculator',
  component: () => import('../../routes/OvertimeCalculator.svelte'),
  card: {
    id: 'overtime-calculator',
    title: 'Overtime Calculator',
    description: 'Calculate your overtime pay and see the impact on your annual earnings with different overtime rates.',
    icon: 'schedule',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/overtime-calculator',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Overtime Calculator – Calculate Overtime Pay & Annual Earnings',
    description: 'Free overtime calculator to calculate your weekly and annual overtime pay. See how time-and-a-half or double-time affects your total earnings with detailed breakdowns.',
  },
};

export default meta;
